export default {
  common: {
    clearAll: 'Tout effacer',
    restart: 'Redémarrer'
  },
  download: {
    bodyText:
      'Cliquez sur le lien de téléchargement ci-dessous pour télécharger %{products}',
    bothProducts: 'PlayBase et/ou Nexus',
    bodyTextFromAcceptInvitation:
      "Le processus prendra un certain temps. Entre-temps, vous pouvez continuer à utiliser Metrica Sports comme d'habitude.",
    bodyTextFromDeclineInvitation:
      "Tu as refusé l'invitation ! Clique sur le lien de téléchargement ci-dessous pour télécharger %{products}",
    bodyTextFromTrial:
      "Bienvenue à Votre Période d'Essai ! Vérifiez votre email enregistré pour obtenir un lien de vérification (vérifiez le dossier spam).",
    bodyTitle: 'Télécharger',
    bodyTitleFromAcceptInvitation: 'Nous changeons votre compte',
    bodyTitleFromDeclineInvitation: 'Invitation Refusée',
    bodyTitleFromTrial: 'Inscription terminée',
    play2: {
      description:
        "Metrica PlayBase est un outil d'analyse intuitif conçu pour les entraîneurs amateurs et prosumers, les petits clubs et les analystes indépendants. Il simplifie le processus d'évaluation de la performance, le rendant accessible à tous.",
      keyFeature1: {},
      keyFeature2: {},
      keyFeature3: {},
      keyFeature4: {},
      plan1: {},
      plan2: {}
    },
    play3: {
      description:
        "Metrica Nexus est conçu pour les analystes et entraîneurs d'élite à la recherche d'informations complètes sur la performance. Avec des outils avancés à portée de main, vous pouvez améliorer les stratégies de l'équipe et atteindre le succès.",
      keyFeature1: {},
      keyFeature2: {},
      keyFeature3: {},
      keyFeature4: {},
      plan1: {},
      plan2: {}
    },
    thanks:
      'Merci de vous être inscrit chez Metrica Sports ! Pour commencer avec votre essai, téléchargez %{products}.'
  },
  error: {
    restart:
      "On dirait que vous essayez d'utiliser quelque chose que nous sommes encore en train de développer...",
    tryAgainMsg:
      "Veuillez réessayer. Si cette erreur persiste, contactez l'équipe de support de Metrica Sports"
  },
  verifyEmail: {
    generateLink: 'Générez un nouveau lien en vous connectant à Play',
    readyToLogin: 'Vous êtes prêt à vous connecter à Play',
    successfully: 'Email vérifié avec succès',
    unsuccessfully: 'Erreur lors de la vérification du courriel, jeton non valide'
  }
}
